// extracted by mini-css-extract-plugin
export var hidden = "_4a-1";
export var leftPanel = "_4a-2";
export var readonlyInspector = "_4a-3";
export var rightPanel = "_4a-0";